module.exports = __webpack_public_path__ + "static/media/emails.e204212f.svg";